export const REGISTEREDCHILDRENTHISMONTH_LABELS = {
  counter: {
    en: "Registered Children - This Month",
    ta: "பதிவு செய்யப்பட்ட குழந்தைகள் - இந்த மாதம்",
    si: "ලියාපදිංචි දරුවන් - මෙම මාසය",
  },
};
